import { Empty, Segmented } from "antd";
import { MemberInfoTab } from "./MemberInfoTab";
import { TeamsAssignedTab } from "./TeamsAssignedTab";
import { useState } from "react";
import trans from "../../../../utils";

const ViewTeamMember = ({ data, teamsData }) => {
  const [selected, setSelected] = useState("Member Info");

  const renderContent = () => {
    switch (selected) {
      case "Member Info":
        return <MemberInfoTab data={data} />;
      case "Teams Assigned":
        return <TeamsAssignedTab data={data} teamsData={teamsData} />;
      default:
        return null;
    }
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Segmented
          options={[
            { label: trans("Member Info"), value: "Member Info" },
            { label: trans("Teams Assigned"), value: "Teams Assigned" },
          ]}
          block
          value={selected}
          onChange={setSelected}
        />

        <div style={{ marginTop: 16, flex: 1, overflowY: "auto" }}>
          {renderContent()}
        </div>
      </div>
    </>
  );
};

export default ViewTeamMember;
